import type { AxiosService } from "./implementations/axios.service";
import { SubscriptionService } from "./implementations/subscription.service";

export default defineNuxtPlugin((nuxtApp) => {
  const subscription = new SubscriptionService(
    nuxtApp.$axios as AxiosService,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      subscription: subscription,
    },
  };
});